import {Fragment} from 'react'
import Logo from '../../../_metronic/assets/everyvisit-logo-white.svg'
import Dealer from '../assets/industry_dealer_network.png'
import QSR from '../assets/industry_qsr.png'
import Retail from '../assets/industry_retail.png'
import Wellness from '../assets/industry_wellness.png'

export default function RetailPage() {
  return (
    <Fragment>
      <div className='d-flex flex-column flex-root px-10 bg-white' id='kt_app_root'>
        <div className='flex-column flex-column-fluid bg-white' id='kt_app_page'>
          <div className='flex-column-fluid'>
            <div id='' className=''>
              <div className='card'>
                <div
                  className='container-fluid d-flex align-items-stretch justify-content-between pt-8'
                  id='kt_app_header_container'
                >
                  <div className='app-header-logo d-flex align-items-center ps-lg-2 me-lg-10'>
                    <div
                      className='btn btn-icon btn-color-gray-500 btn-active-color-primary w-35px h-35px ms-n2 me-2 d-flex d-lg-none'
                      id='kt_app_sidebar_mobile_toggle'
                    >
                      <i className='ki-outline ki-abstract-14 fs-1'></i>
                    </div>

                    <a href='../sign-in'>
                      <img alt='Logo' src={Logo} className='h-30px' />
                    </a>
                  </div>
                </div>
              </div>

              <div className='card'>
                <div className='card-body p-3 pt-7'>
                  <div className='d-flex flex-column flex-xl-row'>
                    <div className='flex-lg-row-fluid me-xl-15'>
                      <div className='mb-17'>
                        <div className='mb-8'>
                          <a href='#/' className='text-primary fs-2 fw-bold'>
                            Explore our loyalty program features for your retail business!
                          </a>

                          <div className='mt-8'>
                            <div
                              className='bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-350px'
                              style={{
                                backgroundImage: `url(${Retail})`,
                              }}
                            ></div>
                          </div>
                        </div>

                        <div className='fs-5 fw-semibold'>
                          <p>Dear visionary Retail entrepreneurs,</p>

                          <p>
                            In a world where every click, every purchase, and every interaction
                            matter, innovation becomes the currency of success. The path to thriving
                            in this dynamic industry involves not just offering products, but
                            crafting unforgettable shopping experiences.
                          </p>
                          <p>
                            And the gateway to creating these experiences? Our Merchant Portal – the
                            key to unlocking the full potential of our Loyalty Reward Platform,
                            exclusively curated for retail and e-commerce merchants like you.
                          </p>

                          <div className='row mt-6'>
                            <div className='col'>
                              <div className='card shadow-sm'>
                                <div className='card-header'>
                                  <div className='card-title  d-flex flex-column'>
                                    <h3>Point Campaigns</h3>
                                    <span className=' m-0 p-0 fs-5'>
                                      Click to discover inspiring examples.
                                    </span>
                                  </div>
                                </div>
                                <div className='card-body'>
                                  <ul className='p-0 m-0 d-flex flex-column gap-4 list-unstyled'>
                                    <li
                                      className='d-flex align-items-center'
                                      data-bs-toggle='modal'
                                      data-bs-target='#kt_modal_scrollable_2_camp1'
                                    >
                                      <span className='bullet me-5 bg-primary'></span>
                                      <a href='#/' className=''>
                                        Purchase Points (Transaction-Based)
                                      </a>
                                    </li>
                                    <li
                                      className='d-flex align-items-center'
                                      data-bs-toggle='modal'
                                      data-bs-target='#kt_modal_scrollable_2_camp1'
                                    >
                                      <span className='bullet me-5 bg-primary'></span>
                                      <a href='#/' className=''>
                                        Welcome Points (Enrollment-Based)
                                      </a>
                                    </li>
                                    <li
                                      className='d-flex align-items-center'
                                      data-bs-toggle='modal'
                                      data-bs-target='#kt_modal_scrollable_2_camp1'
                                    >
                                      <span className='bullet me-5 bg-primary'></span>
                                      <a href='#/' className=''>
                                        Referral Reward (Action-Based)
                                      </a>
                                    </li>
                                    <li
                                      className='d-flex align-items-center'
                                      data-bs-toggle='modal'
                                      data-bs-target='#kt_modal_scrollable_2_camp1'
                                    >
                                      <span className='bullet me-5 bg-primary'></span>
                                      <a href='#/' className=''>
                                        Product Review Points (Action-Based)
                                      </a>
                                    </li>
                                    <li
                                      className='d-flex align-items-center'
                                      data-bs-toggle='modal'
                                      data-bs-target='#kt_modal_scrollable_2_camp1'
                                    >
                                      <span className='bullet me-5 bg-primary'></span>
                                      <a href='#/' className=''>
                                        Anniversary Bonus (Ongoing)
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className='col'>
                              <div className='card shadow-sm'>
                                <div className='card-header'>
                                  <div className='card-title  d-flex flex-column'>
                                    <h3>Discount Campaigns</h3>
                                    <span className=' m-0 p-0 fs-5'>
                                      Click to discover inspiring examples.
                                    </span>
                                  </div>
                                </div>
                                <div className='card-body'>
                                  <ul className='p-0 m-0 d-flex flex-column gap-4 list-unstyled'>
                                    <li
                                      data-bs-toggle='modal'
                                      data-bs-target='#kt_modal_scrollable_2_camp1'
                                    >
                                      <span className='bullet me-5 bg-primary'></span>
                                      <a href='#/' className=''>
                                        Fixed Amount - Percentage Discounts
                                      </a>
                                    </li>
                                    <li
                                      data-bs-toggle='modal'
                                      data-bs-target='#kt_modal_scrollable_2_camp1'
                                    >
                                      <span className='bullet me-5 bg-primary'></span>
                                      <a href='#/' className=''>
                                        Fix Price per Unit
                                      </a>
                                    </li>
                                    <li>
                                      <span className='bullet me-5 bg-primary'></span>
                                      <a href='#/' className=''>
                                        Bundle Set Discount
                                      </a>
                                    </li>
                                    <li>
                                      <span className='bullet me-5 bg-primary'></span>
                                      <a href='#/' className=''>
                                        Store Wide Discount
                                      </a>
                                    </li>
                                    <li>
                                      <span className='bullet me-5 bg-primary'></span>
                                      <a href='#/' className=''>
                                        Specific Product Discount
                                      </a>
                                    </li>
                                    <li>
                                      <span className='bullet me-5 bg-primary'></span>
                                      <a href='#/' className=''>
                                        Bulk/Tiered Discount
                                      </a>
                                    </li>
                                    <li>
                                      <span className='bullet me-5 bg-primary'></span>
                                      <a href='#/' className=''>
                                        Buy X Get X
                                      </a>
                                    </li>
                                    <li>
                                      <span className='bullet me-5 bg-primary'></span>
                                      <a href='#/' className=''>
                                        Buy X Get Y
                                      </a>
                                    </li>
                                    <li>
                                      <span className='bullet me-5 bg-primary'></span>
                                      <a href='#/' className=''>
                                        Buy X Get X (Category)
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='flex-column flex-lg-row-auto w-100 w-xl-300px mb-10'>
                      <div className='m-0'>
                        <h4 className='text-dark mb-11'>By Industries</h4>

                        <div className='d-flex mb-7 align-items-center'>
                          <div className='symbol symbol-100px symbol-2by3 me-4'>
                            <div
                              className='symbol-label'
                              style={{
                                backgroundImage: `url(${Wellness})`,
                              }}
                            ></div>
                          </div>

                          <div className='m-0'>
                            <span className='fw-semibold d-block pt-1 fs-3'>Wellness</span>
                          </div>
                        </div>

                        <div className='d-flex mb-7 align-items-center'>
                          <div className='symbol symbol-100px symbol-2by3 me-4'>
                            <div
                              className='symbol-label'
                              style={{
                                backgroundImage: `url(${Dealer})`,
                              }}
                            ></div>
                          </div>

                          <div className='m-0'>
                            <span className='fw-semibold d-block pt-1 fs-3'>Dealer Network</span>
                          </div>
                        </div>

                        <div className='d-flex mb-7 align-items-center'>
                          <div className='symbol symbol-100px symbol-2by3 me-4'>
                            <div
                              className='symbol-label'
                              style={{
                                backgroundImage: `url(${QSR})`,
                              }}
                            ></div>
                          </div>

                          <div className='m-0'>
                            <span className='fw-semibold d-block pt-1 fs-3'>QSR</span>
                          </div>
                        </div>
                      </div>

                      <div className='modal fade' id='kt_modal_scrollable_2_camp1'>
                        <div
                          className='modal-dialog modal-dialog-scrollable'
                          style={{
                            minWidth: '850px',
                          }}
                        >
                          <div className='modal-content'>
                            <div
                              className='modal-header'
                              style={{
                                backgroundColor: '#fff',
                              }}
                            >
                              <h5 className='modal-title text-gray-900 fs-2'>
                                Fixed Amount - Percentage Discounts
                              </h5>

                              <div
                                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                                data-bs-dismiss='modal'
                                aria-label='Close'
                              >
                                <i className='ki-duotone ki-cross fs-2x'>
                                  <span className='path1'></span>
                                  <span className='path2'></span>
                                </i>
                              </div>
                            </div>

                            <div className='modal-body'>
                              <p>
                                A "Fixed Amount - Percentage Discounts" strategy in a loyalty
                                program for the Retail industry involves offering customers a fixed
                                dollar amount or a percentage discount on their purchase as a
                                loyalty reward.{' '}
                              </p>

                              <p>
                                This strategy provides customers with immediate savings and
                                encouraging them to shop more frequently. It enhances brand loyalty
                                and incentivizes higher spending levels among loyalty program
                                members.
                              </p>

                              <p>
                                <span className='fw-bold fs-4 text-gray-800'>
                                  Examples for Retail:
                                </span>
                              </p>

                              <p>
                                <p className='fw-bold'>Fixed Amount Discount:</p>

                                <p>
                                  - Loyalty Program Members: Get $10 off your next purchase of $50
                                  or more.
                                </p>
                                <p>
                                  - Tier 2 Members: Enjoy an exclusive $20 discount on orders over
                                  $75.
                                </p>
                                <p>
                                  <strong>Percentage Discount:</strong>
                                  <br />
                                  <br />
                                  - All Loyalty Program Members: Receive a 15% discount on your
                                  entire purchase.
                                  <br />
                                  -Tier3 Members: Enjoy an exclusive 20% discount on all products.
                                  <br />
                                  <br />
                                  <strong>Special Category Discount (Percentage):</strong>
                                  <br />
                                  <br />
                                  -LoyaltyProgram Members: Get 20% off all shoes in the store.
                                  <br />
                                  -Tier1 Members: Enjoy an exclusive 25% discount on footwear.
                                  <br />
                                  <br />
                                  <strong>Specific Product Discount (Fixed Amount):</strong>
                                  <br />
                                  <br />
                                  -AllLoyalty Program Members: Buy Product X and receive $5 off.
                                  <br />
                                  -Tier2 Members: Purchase Product Y and get an exclusive $10
                                  discount.
                                  <br />
                                  <br />
                                  <strong>Tiered Discount (Percentage):</strong>
                                  <br />
                                  <br />
                                  -LoyaltyProgram Members: Receive a 10% discount on orders up to
                                  $100, 15% off on orders between $100 and $200, and 20% off on
                                  orders over $200.
                                  <br />
                                  -Tier3 Members: Enjoy an additional 5% discount in each tier.
                                </p>

                                <p>&nbsp;</p>
                              </p>
                            </div>

                            <div className='modal-footer'>
                              <button
                                type='button'
                                className='btn btn-light'
                                data-bs-dismiss='modal'
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id='kt_app_footer' className='app-footer sticky-bottom'>
        <div className='app-container container-fluid d-flex flex-column flex-md-row flex-center justify-content-start flex-md-stack py-3 bg-primary'>
          <div className='text-white fs-3 px-3'>Amplify Your Sales Today and Every Day!</div>

          <div className='d-flex flex-stack'>
            <a
              href='/become-a-merchant/pricing'
              className='p-2 px-4 rounded w-100 ms-5 text-primary pulse pulse-dark d-flex flex-column flex-start'
              style={{
                backgroundColor: '#fff',
              }}
            >
              <div className='d-flex flex-row align-items-center gap-2'>
                <div className='d-flex align-items-center'>
                  <i className='bi bi-arrow-right-circle me-3 fs-3 text-primary'></i>
                </div>
                <div className='d-flex flex-column'>
                  <span className='fs-5 fw-bold'>Become a Merchant</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </Fragment>
  )
}
